import React from 'react';
import { VideoCardVariant } from './VideoCard';

export interface VideoCardSkeletonProps {
    variant?: VideoCardVariant;
}

/**
 * Skeleton placeholder for video cards.
 */
const VideoCardSkeleton = ({ variant = 'grid' }: VideoCardSkeletonProps) => {
    const isCompact = variant === 'compact';

    return (
        <div className={`h-full animate-pulse ${isCompact ? 'flex flex-col gap-3 sm:flex-row sm:gap-4' : 'flex flex-col gap-3'}`} aria-hidden="true">
            <div className={`${isCompact ? 'w-full shrink-0 sm:w-44' : 'w-full'} aspect-video rounded-lg bg-slate-200`} />
            <div className="flex flex-1 flex-col gap-2">
                <div className="h-4 w-3/4 rounded bg-slate-200" />
                <div className="h-4 w-full rounded bg-slate-200" />
                <div className="h-3 w-2/3 rounded bg-slate-200" />
            </div>
        </div>
    );
};

export default VideoCardSkeleton;
